import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import intl from 'react-intl-universal'
import Header from '../Header'
import BookingResult from './BookingResult'
import BookingOption from './BookOption'
import InputBookData from './InputBookData'
import { resetBookingOption } from '../../store/reducers/hotel'
import './index.less'

const BookingBox = ({ title, children, callback, dates, productInfo, from, products, merchantInfo, productRule }) => {
    let defaultStep = 1
    if (productInfo?.type === 1) {
        defaultStep = 2
    }
    const dispatch = useDispatch()
    const [step, setStep] = useState(defaultStep)
    const [orderId, setOrderId] = useState(null)

    const goBack = () => {
        if (step === 1 || step === 3) {
            dispatch(resetBookingOption())
            callback && callback(step)
        } else {
            if (productInfo?.type === 1 && step === 2) {
                callback && callback(step)
            } else {
                setStep(step - 1)
            }

        }
    }

    const handleNext = (num, orderId) => {
        if (typeof num === 'number') {
            setStep(num)
        } else {
            if (step === 3) return
            setStep(step + 1)
        }
        if (orderId) {
            setOrderId(orderId)
        }
    }

    const renderTitle = () => {
        switch (step) {
            case 1:
                return intl.get('h_book_option').d('Book Option')
            case 2:
                return intl.get('reservation_summary').d('Reservation Summary')
            case 3:
                return intl.get('reservation_detail').d('Reservation Details')
        }
    }

    useEffect(() => {
        // setProductUnit(productInfo?.quantity || 1)
    }, [productInfo])


    const totalQuantity = products.reduce((acc, item) => acc + item.quantity, 0)
    console.log(totalQuantity, '///===totalQuantity==///')

    return (
        <div className='bk-wrapper'>
            <Header callback={goBack} title={renderTitle()} />
            <div>
                {step === 3
                    ?
                    <>
                        <BookingResult result={{ status: 1 }} callback={callback} orderId={orderId}>
                            {children ? <><br /><br />{children}<br /><br /></> : null}
                        </BookingResult>
                    </>
                    :
                    <>
                        <BookingOption
                            isShow={step === 1}
                            handleNext={handleNext}
                            openTime='11:00' 
                            closeTime='23:00'
                            dates={dates}
                            productInfo={productInfo}
                            merchantInfo={merchantInfo}
                            totalQuantity={totalQuantity}
                            productRule={productRule}
                            from={from}
                        >
                            <div className='p10' style={{ backgroundColor: '#f5f5f5' }}>
                                {/* {children} */}
                                {
                                    productInfo && (
                                        <div className='jm-flex'>
                                            <div className='jm-flex-item fs-16'>
                                                {productInfo.productName}
                                            </div>

                                        </div>
                                    )
                                }

                            </div>
                        </BookingOption>
                        <InputBookData
                            isShow={step === 2}
                            handleNext={handleNext}
                            productInfo={productInfo}
                            from={from}
                            products={products}
                            merchantInfo={merchantInfo}
                        />
                    </>
                }
            </div>
        </div>
    )
}

export default BookingBox
